module.exports = __webpack_public_path__ + "fontawesome-webfont.b06871f281fee6b241d6.ttf";


//////////////////
// WEBPACK FOOTER
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/~/font-awesome/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = ../../../../font-awesome/fonts/fontawesome-webfont.ttf?v=4.7.0
// module chunks = 9